@if (phoneNumber) {
  <h5>{{ header }}</h5>
  <div class="detail-item">
    <a [routerLink]="['/', phoneNumbersRoute, phoneNumber.phoneNumberId]">
      {{ phoneNumber.phoneNumber | formatPhoneNumbers
      }}@if (phoneNumber.displayName) {
      <span> - {{ phoneNumber.displayName }}</span>
    }
  </a>
</div>
}
